import axiosInstance from './axiosConfig';

export const getMatchesApi = (params) => axiosInstance.get('/matches', { params });
export const getMatchApi = (id) => axiosInstance.get(`/matches/${id}`);
export const createMatchApi = (payload) => axiosInstance.post('/matches', payload);
export const updateMatchApi = (id, payload) => axiosInstance.put(`/matches/${id}`, payload);
export const deleteMatchApi = (id) => axiosInstance.delete(`/matches/${id}`);
export const hardDeleteMatchApi = (id) => axiosInstance.delete(`/matches/${id}/permanent`);
export const recordMatchResultApi = (id, payload) =>
  axiosInstance.post(`/matches/${id}/result`, payload);

export const getPublicMatchesApi = (params) => axiosInstance.get('/public/matches', { params });
export const getPublicMatchApi = (id) => axiosInstance.get(`/public/matches/${id}`);
export const getPublicStandingsApi = (tournamentId) =>
  axiosInstance.get(`/public/standings/${tournamentId}`);
export const getPublicClubsApi = (params) =>
  axiosInstance.get('/public/clubs', { params });

export const getPublicClubApi = (id) =>
  axiosInstance.get(`/public/clubs/${id}`);

export const getPublicPlayerApi = (id) =>
  axiosInstance.get(`/public/players/${id}`);

export const exportMatchesApi = (params) =>
  axiosInstance.get('/matches/export', { params, responseType: 'blob' });

export const getTopPlayersApi = (params) =>
  axiosInstance.get('/public/top-players', { params });
